import { memo } from 'react';

interface BarRowProps {
  label: string;
  sublabel?: string;
  percentage: number;
  value: React.ReactNode;
}

const BarRow = memo(({ label, sublabel, percentage, value }: BarRowProps) => (
  <div className="flex items-center gap-4 py-3 border-b border-slate-50 last:border-0">
    <div className="min-w-[140px]">
      <p className="text-sm font-medium text-blue-950 m-0">{label}</p>
      {sublabel && <p className="text-xs text-slate-400 m-0">{sublabel}</p>}
    </div>
    <div className="flex-1 flex items-center gap-3">
      <div className="flex-1 h-2 bg-slate-100 rounded-full overflow-hidden">
        <div
          className="h-full rounded-full bg-gradient-to-r from-blue-500 to-orange-500
                     transition-all duration-500"
          style={{ width: `${percentage}%` }}
        />
      </div>
      <div className="text-xs font-semibold text-slate-600 min-w-[80px] text-right">
        {value}
      </div>
    </div>
  </div>
));

BarRow.displayName = 'BarRow';

export default BarRow;